
import color from "../../../../../constants/color";

const style = {
  cardGraph : {
    mt:2,
    backgroundColor:"#fff",
    padding:"4%",
    borderRadius:"20px",
    alignItems:"center  ",
    justifyContent:"space-Between",
    width: "100%",
    
  },
  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px", 
  },
    
  SalesHeading: {
    fontSize: "18px",
    fontWeight: "600",
  },
  salesGrid: {
    display: "flex",
    alignItems:"center",
    // width: "50%"
    mr:1
  },
  greenDot:{
    backgroundColor:color.primary,
    height:"12px",
    width:"12px",
    borderRadius: "50%",
    mr:1,
  },
  greyDot:{
    backgroundColor:color.lightText,
    height:"12px",
    width:"12px",
    borderRadius: "50%",
    mr:1,
  },
  detailTexts:{
    fontSize:"12px",
    fontWeight:"400",
    color:color.lightText, 
  },



  
  





}
export default style;